<template>
<div class="main-container">
    <ctcSlab />
  
</div>
</template>

<script>

import ctcSlab from "./CTC.vue"

export default {
  name: 'CTCIntro',
  data() {
    return {
      showIntro: true
    }
  },
  components: {
     ctcSlab
  },
}
</script>

<style lang="scss" scoped>
.image {
  margin-top: 30px;
}

.row-container {
  .value {
    margin-right: 0;
  }
}

.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
}

.closeImage {
  float: right;
  margin: -10px;
  cursor: pointer;
}

.building {
  width: 56px;
  height: 58px;
  object-fit: contain;
  margin: 25px 0 0 129px;
}

.fontStyle {
  margin-left: 20px;
  font-family: Montserrat;
  font-size: 16px;
  color: #404040;
}

.divider {
  color: #34c0be;
  border-bottom: 2px solid #34c0be;
  width: 60%;
  margin: 30px 0 0 5px;

}

.placeAtEnd {
  margin-top: 130px;
}
</style>
